import { makeObservable, observable } from "mobx";
import type { ModuleTabsStore } from "src/system/layout/ModuleTabsProvider.tsx";

export class GlobalModuleTabsStore {
  @observable
  state: Record<string, ModuleTabsStore> = {};

  constructor({ state }: { state: Record<string, ModuleTabsStore> }) {
    this.state = state;
    makeObservable(this);
  }
}
